import FacilitiesDashboard from "../../components/FacilitiesDashboard";
import FacilitiesReports from "../../components/FacilitiesReports";
import FacilitiesPropertyIssues from "../../components/FacilitiesPropertyIssues";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

export const facilitiesConfig = [
  {
    path: "/facilitiesDashboard",
    component: FacilitiesDashboard,
    label: "Dashboard",
    icon: DashboardIcon,
    showInNav: true,
  },
  {
    path: "/facilitiesReports",
    component: FacilitiesReports,
    label: "Reports",
    icon: AssessmentIcon,
    showInNav: true,
  },
  {
    path: "/facilitiesPropertyIssues",
    component: FacilitiesPropertyIssues,
    label: "Property Issues",
    icon: ReportProblemIcon,
    showInNav: true,
  },
];

export const facilitiesMetadata = {
  roleName: "Facilities",
  defaultRoute: "/facilitiesDashboard",
};
